import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    Switch,
    FormControl,
    FormControlLabel,
    FormGroup,
    Checkbox,
    Typography,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import Popup from 'components/popup/popup';
import { userRoles, CLUSTER_ADMIN, IRB, SECRETARY } from 'utility/lookup';
import { getTimeWithTimeZone, emptyShow } from 'utility/general';
import { useSelector, useDispatch } from 'react-redux';
import HospitalOrInstitutions from 'components/Global/HospitalOrInstitutions';
import PasswordTextField from 'components/Input/PasswordTextField';
import CustomTextField from 'components/Input/CustomTextField';
import { SYSTEM_GET_USER_ACCOUNT_DETAIL } from 'store/key';
import { checkIsAuthorizedEmail, checkIsFormattedHospital } from 'utility/checkValidations';
// import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
// import CustomDatePicker from 'components/Input/CustomDatePicker';

const useStyles = makeStyles((theme) => ({
    container: {
        flex: 1,
        overflow: 'auto',
        paddingRight: 15,
    },
    title: {
        fontWeight: 'bold',
    },
    item: {
        marginTop: theme.spacing(2),
    },
    radioGroup: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
    },
    formGroup: {
        width: '100%',
    },
    formLabel: {
        fontWeight: 'bold',
        padding: '12px 16px 0 0',
    },
    value: {
        padding: '10.5px 0',
    },
    listSubheader: {
        background: '#fff',
    },
    menuItem: {
        paddingLeft: '26px',
    },
}));

const CreateEditAccount = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    /** hide list for role */
    const hideList = [CLUSTER_ADMIN, IRB, SECRETARY];

    const systemMessage = useSelector((state) => state.systemMessage.systemMessage);
    const _roleList = useSelector((state) => state.userAccount.roleList);
    const _clusterList = useSelector((state) => state.userAccount.clusterList);
    const _irbList = useSelector((state) => state.userAccount.irbList);
    const _secretaryList = useSelector((state) => state.userAccount.secretaryList);
    let userAccountDetail = useSelector((state) => state.userAccount.userAccountDetail);
    const isLoading = useSelector((state) => state.userAccount.isLoading);
    userAccountDetail = props.popupType === 'edit' ? userAccountDetail : null;

    const rowData = userAccountDetail && props.popupType === 'edit' ? userAccountDetail : null;
    const [email, setEmail] = useState(userAccountDetail ? userAccountDetail.email : '');
    const [title, setTitle] = useState(userAccountDetail ? userAccountDetail.title : '');
    const [firstName, setFirstName] = useState(userAccountDetail ? userAccountDetail.firstName : '');
    const [surname, setSurname] = useState(userAccountDetail ? userAccountDetail.surname : '');
    const [hospitalOrInstitution, setHospitalOrInstitution] = useState(
        userAccountDetail ? userAccountDetail.institution : '',
    );
    const [contactNumber, setContactNumber] = useState(userAccountDetail ? userAccountDetail.contact : '');
    const [justification, setJustification] = useState(userAccountDetail ? userAccountDetail.justification : '');
    const [status, setStatus] = useState(userAccountDetail ? userAccountDetail.status : 0);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [description, setDescription] = useState(userAccountDetail ? userAccountDetail.description : '');
    const [lastLoginDtm, setLastLoginDtm] = useState(
        emptyShow(
            userAccountDetail && userAccountDetail.lastLoginDtm
                ? getTimeWithTimeZone(userAccountDetail.lastLoginDtm).format('YYYY-MM-DD HH:mm:ss')
                : '',
        ),
    );

    const [isAuthorizedEmail, setCheckAuthorizedEmail] = useState(false);

    const [forceShowError, setForceShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const formDataValid = useRef({
        email: true,
        title: true,
        firstName: true,
        surname: true,
        hospitalOrInstitution: true,
        contactNumber: true,
        password: true,
        confirmPassword: true,
        description: true,
    });

    const [roleList, setRoleList] = useState(_roleList);
    const [clusterList, setClusterList] = useState(_clusterList);

    const [irbList] = useState(_irbList);
    const [secretaryList] = useState(_secretaryList);

    const [irbCode, setIrbCode] = useState(userAccountDetail ? userAccountDetail.irbSubType : null);
    const [secretaryCode, setSecretaryCode] = useState(userAccountDetail ? userAccountDetail.secretarySubType : null);

    const showEnable = props.popupType === 'edit' && [0, 3].includes(userAccountDetail?.status);
    const isEdit = props.popupType === 'edit' && userAccountDetail !== null;

    const forcePwdValid = password === '' && isEdit;

    console.log('161723 createEdit.js roleList', roleList);

    useEffect(() => {
        if (props.popupType === 'edit') {
            dispatch({
                type: SYSTEM_GET_USER_ACCOUNT_DETAIL,
                payload: {
                    userid: props.rowData.id,
                },
            });
        }

        return () => {
            let clusterList = _clusterList.map((item) => {
                item.checked = false;
                return item;
            });
            let roleList = _roleList.map((item) => {
                item.checked = false;
                return item;
            });
            setRoleList(roleList);
            setClusterList(clusterList);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isEdit) {
            initialData();
        } else {
            let clusterList = _clusterList.map((item) => {
                item.checked = false;
                return item;
            });
            let roleList = _roleList.map((item) => {
                item.checked = false;
                return item;
            });
            setRoleList(roleList);
            setClusterList(clusterList);
        }
        // eslint-disable-next-line
    }, [userAccountDetail]);

    const initialData = async () => {
        await setEmail(isEdit ? userAccountDetail.email : '');
        await setTitle(isEdit ? userAccountDetail.title : '');
        await setFirstName(isEdit ? userAccountDetail.firstName : '');
        await setSurname(isEdit ? userAccountDetail.surname : '');
        await setHospitalOrInstitution(isEdit ? userAccountDetail.institution : '');
        await setContactNumber(isEdit ? userAccountDetail.contact : '');
        await setJustification(isEdit ? userAccountDetail.justification : '');
        await setStatus(isEdit ? userAccountDetail.status : 0);
        await setDescription(isEdit ? userAccountDetail.description : '');
        await setLastLoginDtm(
            emptyShow(
                isEdit && userAccountDetail.lastLoginDtm
                    ? getTimeWithTimeZone(userAccountDetail.lastLoginDtm).format('YYYY-MM-DD HH:mm:ss')
                    : '',
            ),
        );
        await setPassword('');
        await setConfirmPassword('');

        await setIrbCode(isEdit ? userAccountDetail.irbSubType : '');
        await setSecretaryCode(isEdit ? userAccountDetail.secretarySubType : '');

        if (isEdit) {
            let clusterList = _clusterList.map((item) => {
                if (userAccountDetail && userAccountDetail.clusters && userAccountDetail.clusters.includes(item.id))
                    item.checked = true;
                else item.checked = false;
                return item;
            });
            let roleList = _roleList.map((item) => {
                if (userAccountDetail && userAccountDetail.roles && userAccountDetail.roles.includes(item.id))
                    item.checked = true;
                else item.checked = false;
                return item;
            });

            await setRoleList(roleList);
            await setClusterList(clusterList);
        } else {
            let clusterList = _clusterList.map((item) => {
                item.checked = false;
                return item;
            });
            let roleList = _roleList.map((item) => {
                item.checked = false;
                return item;
            });
            await setRoleList(roleList);
            await setClusterList(clusterList);
        }

        /** check user group valid */
        checkUserGroups();
    };

    const emailOnChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        const isAuthorizedEmail = checkIsAuthorizedEmail(value);

        /** reset hospitalOrInstitution,value = '' when not found hospitalName && hospitalCode from formattedHospitalData*/
        if (isAuthorizedEmail && !checkIsFormattedHospital(hospitalOrInstitution)) {
            setHospitalOrInstitution('');
        }

        setCheckAuthorizedEmail(isAuthorizedEmail);
    };

    const handleChange = async (e, type, id) => {
        if (type === 'irb') {
            let value = e.target.value;
            if (value === irbCode) value = null;
            await setIrbCode(value);
        } else if (type === 'secretary') {
            let value = e.target.value;
            if (value === secretaryCode) value = null;
            await setSecretaryCode(value);
        } else if (type === 'role') {
            let list = [...roleList];
            list.find((item) => item.id === id).checked = e.target.checked;
            await setRoleList(list);
        } else {
            let list = [...clusterList];
            list.find((item) => item.id === id).checked = e.target.checked;
            await setClusterList(list);
        }

        /** check user group valid */
        checkUserGroups();
    };

    const checkUserGroups = () => {
        let error = false;
        const userGroupChecked = roleList.find((item) => item.checked) || clusterList.find((item) => item.checked);

        if (!userGroupChecked && !irbCode && !secretaryCode) {
            error = true;
            setErrorMessage(systemMessage.selectedAtLeastOne);
        } else {
            setErrorMessage('');
        }
        return error;
    };

    const checkForm = () => {
        const list = formDataValid.current;
        const error = Object.keys(list).some((key) => {
            return list[key] === false;
        });
        return error;
    };

    const confirm = () => {
        setForceShowError(true);
        let valid = !checkForm();
        valid = !checkUserGroups() && valid;
        if (valid) {
            let params = {
                email: email,
                title: title,
                firstName: firstName,
                surname: surname,
                institution: hospitalOrInstitution,
                contact: contactNumber,
                justification: justification,
                confirmPassword: confirmPassword ? confirmPassword : null,
                password: password ? password : null,
                roles: [],
                cluster: [],
                description: description,
                irbSubType: irbCode,
                secretarySubType: secretaryCode,
            };

            if (props.popupType === 'edit' && showEnable) {
                params.status = status;
            }

            const rlist = roleList.filter((item) => !hideList.includes(item.role));
            rlist.forEach((item) => {
                item.checked && params.roles.push(item.id);
            });
            clusterList.forEach((item) => {
                item.checked && params.cluster.push(item.id);
            });
            if (props.popupType === 'edit') {
                props.updateUser({ ...userAccountDetail, ...params });
            } else {
                props.createUser(params);
            }
        }
    };

    const cancel = () => {
        props.setOpenPopup(false);
    };

    const reset = () => {
        setForceShowError(true);
        initialData();
    };

    const footerActions = [
        { label: 'Cancel', clicked: cancel, color: 'default' },
        { label: 'Reset', clicked: reset },
        { label: 'Confirm', clicked: confirm },
    ];

    // const shouldReviewerRender = () => {
    //     const reviewerRole = roleList.find((item) => item.role === 'reviewer');

    //     if (reviewerRole) {
    //         if (reviewerRole.checked) {
    //             return true;
    //         }
    //     }

    //     return false;
    // };

    return (
        <Popup
            isLoading={isLoading}
            height="95%"
            width="65%"
            title={rowData ? 'Edit Account' : 'Create Account'}
            open={props.openPopup}
            footerActions={footerActions}
            closePopup={cancel}
        >
            <Grid container wrap="nowrap" direction="column" className={classes.container}>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Email:
                    </Grid>
                    <Grid container item xs={10}>
                        <CustomTextField
                            label="Email"
                            name="email"
                            value={email}
                            onChange={emailOnChange}
                            validators={['isRequired', 'disableChinese', 'isEmail']}
                            isValidValue={(valid) => (formDataValid.current.email = valid)}
                            forceErrorDisplay={forceShowError}
                            isNoSpace
                            maxLength={255}
                            disabled={isEdit}
                            showErrorWhenOnBlur
                        />
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Title:
                    </Grid>
                    <Grid container item xs={10}>
                        <CustomTextField
                            label="Title"
                            name="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            validators={['isRequired', 'disableChinese']}
                            isValidValue={(valid) => (formDataValid.current.title = valid)}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" className={classes.item}>
                    <Grid container item xs={6} alignItems="center">
                        <Grid container item xs={4} className={classes.title}>
                            First Name:
                        </Grid>
                        <Grid container item xs={7}>
                            <CustomTextField
                                label="First Name"
                                name="firstName"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                validators={['isRequired', 'disableChinese']}
                                isValidValue={(valid) => (formDataValid.current.firstName = valid)}
                                forceErrorDisplay={forceShowError}
                                maxLength={255}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={6} alignItems="center">
                        <Grid container item xs={2} className={classes.title}>
                            Surname:
                        </Grid>
                        <Grid container item xs={7}>
                            <CustomTextField
                                label="Surname"
                                name="surname"
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                                validators={['isRequired', 'disableChinese']}
                                isValidValue={(valid) => (formDataValid.current.surname = valid)}
                                forceErrorDisplay={forceShowError}
                                maxLength={255}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Hospital / Institution:
                    </Grid>
                    <Grid container item xs={10}>
                        <HospitalOrInstitutions
                            isAuthorizedEmail={isAuthorizedEmail}
                            hospitalOrInstitution={hospitalOrInstitution}
                            setHospitalOrInstitution={(e) => setHospitalOrInstitution(e.target.value)}
                            validators={['isRequired', 'disableChinese']}
                            isValidValue={(valid) => (formDataValid.current.hospitalOrInstitution = valid)}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Contact Number:
                    </Grid>
                    <Grid container item xs={10}>
                        <CustomTextField
                            label="Contact Number"
                            name="contactNumber"
                            value={contactNumber}
                            onChange={(e) => setContactNumber(e.target.value)}
                            validators={['isRequired', 'disableChinese', 'disableAlphabet']}
                            isValidValue={(valid) => (formDataValid.current.contactNumber = valid)}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                {rowData ? (
                    <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                        <Grid container item xs={2} className={classes.title}>
                            Justification:
                        </Grid>
                        <Grid container item xs={10}>
                            <CustomTextField
                                // helperText="*Please give justification for using non-HA authorized email address"
                                label="Justification"
                                name="justification"
                                value={justification}
                                onChange={(e) => setJustification(e.target.value)}
                                validators={['disableChinese']}
                                isValidValue={(valid) => (formDataValid.current.contactNumber = valid)}
                                forceErrorDisplay={forceShowError}
                                maxLength={255}
                            />
                        </Grid>
                    </Grid>
                ) : null}
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Password:
                    </Grid>
                    <Grid container item xs={10}>
                        <PasswordTextField
                            name="password"
                            label="Password"
                            value={password}
                            handleChange={(e) => setPassword(e.target.value)}
                            validators={
                                isEdit
                                    ? ['disableChinese', 'checkPassword']
                                    : ['isRequired', 'disableChinese', 'checkPassword']
                            }
                            isValidValue={(valid) => {
                                formDataValid.current.password = valid;
                            }}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                            forceValid={forcePwdValid}
                        />
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Confirm Password:
                    </Grid>
                    <Grid container item xs={10}>
                        <PasswordTextField
                            name="confirmPassword"
                            label="Confirm Password"
                            value={confirmPassword}
                            handleChange={(e) => setConfirmPassword(e.target.value)}
                            validators={
                                isEdit
                                    ? ['disableChinese', 'checkConfirmPassword']
                                    : ['isRequired', 'disableChinese', 'checkConfirmPassword']
                            }
                            isValidValue={(valid) => (formDataValid.current.confirmPassword = valid)}
                            forceErrorDisplay={forceShowError}
                            confirmPasswordNotMatchPassword={confirmPassword !== password}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="baseline" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        User Group:
                    </Grid>
                    <Grid container item xs={10}>
                        <FormControl>
                            <FormGroup row>
                                {roleList.map((role, rIdx) => {
                                    const displayName = userRoles
                                        .filter((item) => !hideList.includes(item.key))
                                        .find((item) => {
                                            return item.key === role.role;
                                        })?.display;

                                    if (!displayName) {
                                        return null;
                                    }
                                    return (
                                        <FormControlLabel
                                            key={`role${rIdx}`}
                                            control={
                                                <Checkbox
                                                    disabled={role.role === 'reviewer'}
                                                    color="primary"
                                                    checked={role.checked}
                                                    onChange={(e) => handleChange(e, 'role', role.id)}
                                                    name={`roleName${role.id}`}
                                                />
                                            }
                                            label={displayName}
                                        />
                                    );
                                })}
                                <FormGroup className={classes.formGroup} row>
                                    <Grid container wrap="nowrap" item xs={12}>
                                        <Grid className={classes.formLabel}>Cluster Admin:</Grid>
                                        <Grid container item xs={10}>
                                            {clusterList.map((cluster, cIdx) => {
                                                return (
                                                    <FormControlLabel
                                                        key={`cluster${cIdx}`}
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={cluster.checked}
                                                                onChange={(e) => handleChange(e, 'cluster', cluster.id)}
                                                                name={cluster.clusterCode}
                                                            />
                                                        }
                                                        label={cluster.clusterName}
                                                    />
                                                );
                                            })}
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                                {/**
                                 * 1、 Central IRB: it should be divided into “Central IRB (Routine Panel)” and “Central IRB (PAED Panel)”
                                 *  2、Secretary: it should be divided into “Secretary (HKWC)” and “Secretary (NTEC)”.
                                 * */}
                                <FormGroup className={classes.formGroup} row>
                                    <Grid className={classes.formLabel}>Central IRB:</Grid>
                                    <RadioGroup row value={irbCode}>
                                        {irbList.map((item) => (
                                            <FormControlLabel
                                                key={item.code}
                                                value={item.code}
                                                control={
                                                    <Radio onClick={(e) => handleChange(e, 'irb')} color="primary" />
                                                }
                                                label={item.name}
                                                checked={irbCode === item.code}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormGroup>
                                <FormGroup className={classes.formGroup} row>
                                    <Grid className={classes.formLabel}>Secretary:</Grid>
                                    <RadioGroup row value={secretaryCode}>
                                        {secretaryList.map((item) => (
                                            <FormControlLabel
                                                key={item.code}
                                                value={item.code}
                                                control={
                                                    <Radio
                                                        onClick={(e) => handleChange(e, 'secretary')}
                                                        color="primary"
                                                    />
                                                }
                                                label={item.name}
                                                checked={secretaryCode === item.code}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormGroup>
                            </FormGroup>
                        </FormControl>
                        {forceShowError && errorMessage ? <Typography color="error">{errorMessage}</Typography> : null}
                    </Grid>
                </Grid>
                {/* {shouldReviewerRender() && (
                    <Grid container wrap="nowrap" alignItems="baseline" className={classes.item}>
                        <Grid container item xs={2} className={classes.title}>
                            Reviewer Info:
                        </Grid>
                        <Grid container item xs={10}>
                            <div style={{ width: '100%' }}>
                                <div>
                                    <CustomOutlineSelect
                                        value={'M'}
                                        label={'Gender'}
                                        onChange={(e) => {}}
                                        choices={[
                                            {
                                                key: 'M',
                                                display: 'Male',
                                            },
                                            {
                                                key: 'F',
                                                display: 'Female',
                                            },
                                        ]}
                                    />
                                </div>
                                <div style={{ marginTop: 15 }}>
                                    <CustomDatePicker label={'Start Date'} />
                                </div>
                                <div style={{ marginTop: 15 }}>
                                    <CustomDatePicker label={'End Date'} />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                )} */}
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    {showEnable && (
                        <Grid container item xs={6} alignItems="center">
                            <Grid container item xs={4} className={classes.title}>
                                Enable:
                            </Grid>
                            <Grid container item xs={7}>
                                <Switch
                                    color="primary"
                                    checked={status === 0 ? true : false}
                                    onChange={(e) => setStatus(e.target.checked ? 0 : 3)}
                                />
                            </Grid>
                        </Grid>
                    )}
                    {rowData && (
                        <Grid container item xs={6} alignItems="center">
                            <Grid container item xs={4} className={classes.title}>
                                Last Login:
                            </Grid>
                            <Grid container item xs={7}>
                                {lastLoginDtm}
                            </Grid>
                        </Grid>
                    )}
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Description:
                    </Grid>
                    <Grid container item xs={10}>
                        <CustomTextField
                            label="Description"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            validators={['isRequired', 'disableChinese']}
                            isValidValue={(valid) => (formDataValid.current.description = valid)}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Popup>
    );
};

export default CreateEditAccount;
